module.exports = __webpack_public_path__ + "static/tanayv-6670a5993aa9c294c6f2f908bdd4f2eb.jpeg";